module.exports = __webpack_public_path__ + "img/dg-website-brands-banner-side.ebb4d52e.png";